import React from 'react';
import { useTranslation } from 'react-i18next';
import { buildRequestFormViewModel } from 'stores/requests/request-form-store';
import { RequestDto } from 'stores/requests/requests-store';
import MobileRequestElementContainer from './mobile-request-element-container';

export interface MobileRequestsListProps {
  requests: RequestDto[];
  onRequestClick?: (request?: RequestDto) => void;
  onBack?: () => void;
  fromScheduler?: boolean;
}

const MobileRequestsList: React.FC<MobileRequestsListProps> = ({ onRequestClick, requests, onBack, fromScheduler = false }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 p-2">
      {(requests || []).length > 0 ? (
        (requests || []).map((item, i) => (
          <MobileRequestElementContainer
            key={i}
            request={buildRequestFormViewModel(item)}
            selectedRequest={item}
            onClick={i => {
              onRequestClick(i);
            }}
          />
        ))
      ) : (
        <div className="p-4  relative">
          {!fromScheduler && (
            <div className="flex items-center mb-2">
              <button
                onClick={() => {
                  onBack && onBack();
                }}
                className="flex items-center gap-1 text-sm text-black-600"
              >
                ← Back
              </button>
            </div>
          )}

          <div className="flex justify-center items-center p-4 text-gray-500">{t('No requests available for selection')}.</div>
        </div>
      )}
    </div>
  );
};

export default MobileRequestsList;
